import { FieldComponentProps } from '..';

import { CloudinaryPhoto } from './CloudinaryPhoto'
import { CloudinaryPhotoInput } from './CloudinaryPhotoInput'

export const CloudinaryPhotoField = {edit: CloudinaryPhotoInput, display: CloudinaryPhoto} as unknown as FieldComponentProps<typeof CloudinaryPhotoInput>;
